// require('jquery');
// window.$ = $;
// window.jQuery = $;

require('lodash');
require('moment');
require('moment-timezone');
require('angular');
require('angular-readable-time');
require('angular-ellipsis');
require('../../vendor/currency-filter-2.1.0.vendor.js');
require('../../vendor/isoCurrency.min.vendor.js');
require('../../vendor/jsbn/base64.vendor.js');
require('../../vendor/jsbn/prng4.vendor.js');
require('../../vendor/jsbn/jsbn.vendor.js');
require('../../vendor/jsbn/rng.vendor.js');
require('../../vendor/jsbn/rsa.vendor.js');
require('../../vendor/ui-bootstrap-tpls-2.3.0.vendor.js');
require('../../vendor/xml2json.vendor.js');


const authModule = require('gw-um-auth/authModule.js');
const coreModule = require('gw-um-core/coreModule.js');
const submissionGridModule = require('gw-um-submission-grid/submissionGridModule.js');
const submissionModule = require('gw-um-submission/submissionModule.js');
const j2jsModule = require('gw-um-j2js/j2jsModule.js');
const umLandingModule = require('./landing/landingModule.js');
const extensionsModule = require('gw-um-extensions/extensionsModule.js');

angular.module('ums', [
    coreModule,
    authModule,
    submissionGridModule,
    submissionModule,
    j2jsModule,
    umLandingModule,
    extensionsModule
])
    .config(function () {})
    .run(function ($location, appTypeConfigurationModel, coreConstant) {
        let consoleType;

        if (_.includes($location.absUrl(), '/umagent')) {
            consoleType = coreConstant.authorization.CONSOLE_TYPE_UM_AGENT;
        }
        else {
            consoleType = coreConstant.authorization.CONSOLE_TYPE_UM;
        }

        appTypeConfigurationModel.setConsoleType(consoleType);
    })
    .baseURL = './';

require('./app.less');
require('./configModule.js');
require('./applicationController.js');

require('./common/businessCard/uiBusinessCard.js');
require('./common/header/appHeaderController.js');
